"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pages = void 0;
var Pages;
(function (Pages) {
    Pages[Pages["NONE"] = -1] = "NONE";
    Pages[Pages["SEARCH"] = 0] = "SEARCH";
    Pages[Pages["SAVE_SEARCH"] = 1] = "SAVE_SEARCH";
    Pages[Pages["DEVELOPMENTS"] = 2] = "DEVELOPMENTS";
    Pages[Pages["ALERT"] = 3] = "ALERT";
    Pages[Pages["ACCOUNT_INFO"] = 4] = "ACCOUNT_INFO";
    Pages[Pages["CHANGE_PASSWORD"] = 5] = "CHANGE_PASSWORD";
    Pages[Pages["LOCATIONS"] = 6] = "LOCATIONS";
    Pages[Pages["CONTACTS"] = 7] = "CONTACTS";
    Pages[Pages["MANAGE_DATA"] = 8] = "MANAGE_DATA";
    Pages[Pages["CONFIRM_EMAIL_REGISTER"] = 9] = "CONFIRM_EMAIL_REGISTER";
    Pages[Pages["LOCKOUT"] = 10] = "LOCKOUT";
    Pages[Pages["FORGOT_PASSWORD"] = 11] = "FORGOT_PASSWORD";
    Pages[Pages["FORGOT_PASSWORD_RESULT"] = 12] = "FORGOT_PASSWORD_RESULT";
    Pages[Pages["REVERIFY_EMAIL"] = 13] = "REVERIFY_EMAIL";
    Pages[Pages["REVERIFY_EMAIL_RESULT"] = 14] = "REVERIFY_EMAIL_RESULT";
    Pages[Pages["CONTACT_AGENT"] = 15] = "CONTACT_AGENT";
    Pages[Pages["STATIC_CONTENT"] = 16] = "STATIC_CONTENT";
    Pages[Pages["INVESTOR"] = 17] = "INVESTOR";
    Pages[Pages["ABOUT"] = 18] = "ABOUT";
    Pages[Pages["ABOUTUS"] = 19] = "ABOUTUS";
    Pages[Pages["PRICE_LIST"] = 20] = "PRICE_LIST";
    Pages[Pages["ACCOUNT_LOGIN"] = 21] = "ACCOUNT_LOGIN";
    Pages[Pages["DEVELOPMENT"] = 22] = "DEVELOPMENT";
    Pages[Pages["HOME"] = 23] = "HOME";
    Pages[Pages["HOME_ZH"] = 24] = "HOME_ZH";
    Pages[Pages["BUILDING"] = 25] = "BUILDING";
    Pages[Pages["LIST_PROPERTY"] = 26] = "LIST_PROPERTY";
    Pages[Pages["AGENT_PROFILE"] = 27] = "AGENT_PROFILE";
    Pages[Pages["DISTRICT"] = 28] = "DISTRICT";
    Pages[Pages["AGENT_LISTING"] = 29] = "AGENT_LISTING";
    Pages[Pages["TESTIMONIALS"] = 30] = "TESTIMONIALS";
    Pages[Pages["NEWS_AND_INSIGHTS"] = 31] = "NEWS_AND_INSIGHTS";
    Pages[Pages["RESOURCES"] = 32] = "RESOURCES";
    Pages[Pages["GUIDES"] = 33] = "GUIDES";
    Pages[Pages["IN_THE_PRESS"] = 34] = "IN_THE_PRESS";
    Pages[Pages["STAMP_DUTY"] = 35] = "STAMP_DUTY";
    Pages[Pages["INSIGHTS"] = 36] = "INSIGHTS";
    Pages[Pages["EXECUTIVE_LISTING"] = 37] = "EXECUTIVE_LISTING";
    Pages[Pages["NEWS_AND_INSIGHTS_DETAIL"] = 38] = "NEWS_AND_INSIGHTS_DETAIL";
    Pages[Pages["DISCOVERY_BAY_GUIDE"] = 41] = "DISCOVERY_BAY_GUIDE";
    Pages[Pages["PROPERTY_DETAIL"] = 44] = "PROPERTY_DETAIL";
    Pages[Pages["ASK_AN_AGENT_LIST"] = 45] = "ASK_AN_AGENT_LIST";
    Pages[Pages["PROPERTY_DETAIL_AMP"] = 46] = "PROPERTY_DETAIL_AMP";
    Pages[Pages["NEWS_AND_INSIGHTS_DETAIL_AMP"] = 47] = "NEWS_AND_INSIGHTS_DETAIL_AMP";
    Pages[Pages["NOT_FOUND"] = 48] = "NOT_FOUND";
    Pages[Pages["DETAIL_NOT_FOUND"] = 49] = "DETAIL_NOT_FOUND";
    Pages[Pages["ASK_AN_AGENT"] = 50] = "ASK_AN_AGENT";
    Pages[Pages["SITEMAP"] = 51] = "SITEMAP";
    Pages[Pages["ENQUIRY_HISTORY"] = 52] = "ENQUIRY_HISTORY";
    Pages[Pages["ESTATE"] = 53] = "ESTATE";
    Pages[Pages["PHASE"] = 54] = "PHASE";
    Pages[Pages["MORTGAGE_REPAYMENT"] = 55] = "MORTGAGE_REPAYMENT";
    Pages[Pages["MORTGAGE_AFFORDABLILTY"] = 56] = "MORTGAGE_AFFORDABLILTY";
    Pages[Pages["MORTGAGE_REFINANCE"] = 57] = "MORTGAGE_REFINANCE";
    Pages[Pages["MORTGAGE"] = 58] = "MORTGAGE";
    Pages[Pages["MORTGAGE_AFFORDABLILTY_BY_PAYMENT"] = 59] = "MORTGAGE_AFFORDABLILTY_BY_PAYMENT";
    Pages[Pages["SAVE_PROPERTIES"] = 60] = "SAVE_PROPERTIES";
    Pages[Pages["RECENTLY_VIEWED"] = 61] = "RECENTLY_VIEWED";
    Pages[Pages["FAQ"] = 62] = "FAQ";
    Pages[Pages["UNSUBSCRIBE"] = 63] = "UNSUBSCRIBE";
    Pages[Pages["DETAIL_NOT_FOUND_AMP"] = 64] = "DETAIL_NOT_FOUND_AMP";
    Pages[Pages["BLOCK"] = 65] = "BLOCK";
    Pages[Pages["PROPERTY_TRANSACTION"] = 66] = "PROPERTY_TRANSACTION";
    Pages[Pages["EXCLUSIVE"] = 67] = "EXCLUSIVE";
    Pages[Pages["PENDING_DOCUMENT"] = 68] = "PENDING_DOCUMENT";
    Pages[Pages["SIGNED_DOCUMENT"] = 69] = "SIGNED_DOCUMENT";
    Pages[Pages["MY_LISTINGS"] = 70] = "MY_LISTINGS";
    Pages[Pages["MY_VIEWINGS"] = 71] = "MY_VIEWINGS";
    Pages[Pages["FIRSTHAND_DEVELOPMENTS"] = 72] = "FIRSTHAND_DEVELOPMENTS";
    Pages[Pages["FIRSTHAND_DEVELOPMENT"] = 73] = "FIRSTHAND_DEVELOPMENT";
})(Pages = exports.Pages || (exports.Pages = {}));
